import { render, staticRenderFns } from "./AlertsFolioModal.vue?vue&type=template&id=4986e94f&scoped=true&"
import script from "./AlertsFolioModal.vue?vue&type=script&lang=js&"
export * from "./AlertsFolioModal.vue?vue&type=script&lang=js&"
import style0 from "./AlertsFolioModal.vue?vue&type=style&index=0&id=4986e94f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4986e94f",
  null
  
)

export default component.exports